<app-modal-container
  [title]="show.title.header"
  [bigSize]="false"
  [buttons]="modalButtons"
  [applyActivated]="is.applyActivated"
  (closeButtonClicked)="closeAsFailed()"
  (applyButtonClicked)="confirm()">
  <div class="centered-column-container align-items-stretch max-height-50vh overflow-auto column-gap-1p25 max-width-80vw">
<!--    I tried to use ngTemplateOutlet. There is a problem, that the text must be updated when a variable changes.-->
<!--    ngTemplateOutlet does render only once and does know about variable changes =/-->
    <div *ngIf="!show.validationMessage"
         data-qa="bulk-upload-notification"
         class="duplicate-notification centered-row-container-flex-start row-gap-0p5">
      <app-all-icons [iconNameAndStyling]="'exclamation.svg; icon-size-1p5; orange-10'"></app-all-icons>
      <div class="start-column-container column-gap-0p5">
        <span *ngIf="show.title.info.main" class="font-2 bold600 black-12">{{show.title.info.main}}</span>
        <span *ngIf="show.title.info.sub" class="font-3 bold500 black-12">{{show.title.info.sub}}</span>
      </div>
    </div>
    <div *ngIf="show.validationMessage"
         data-qa="bulk-upload-validation-notification"
         class="duplicate-notification start-start-row-container row-gap-0p5">
      <app-all-icons [iconNameAndStyling]="'exclamation.svg; icon-size-1p5; orange-10'"></app-all-icons>
      <div class="start-column-container column-gap-0p5">
        <span class="font-2 bold600 black-12">{{show.validationMessage.upperText}}</span>
        <span class="font-3 black-12">{{show.validationMessage.bottomText}}</span>
      </div>
    </div>
    @if (is.dataUploaded && !show.validationMessage) {
      <ng-content/>
    }

<!-- Do show download excel and upload, till no successful file was upload.-->
<!-- E.x. when validation error occurred, it is possible to upload again.-->
    <ng-container *ngIf="!(is.dataUploaded && !show.validationMessage)">
      <div class="centered-row-container row-gap-1">
        <app-button
          data-qa="bulk-upload-download-template-button"
          [size]="'medium'"
          [type]="currentButtonType.download"
          [iconName]="'download-arrow-in-circle.svg'"
          [disabled]="is.uploadDisabled"
          (click)="downloadExcel()">
          Download template
        </app-button>
        <app-button
          data-qa="bulk-upload-upload-data-button"
          [size]="'medium'"
          [type]="currentButtonType.upload"
          [iconName]="'upload-arrow-in-rectangle.svg'"
          [disabled]="is.uploadDisabled"
          (click)="input.click()">
          Upload data
        </app-button>
        <input
          #input
          type="file"
          accept=".xlsx, .xls"
          class="visibility-hidden position-abs"
          data-qa="bulk-upload-upload-data"
          (change)="upload(input)">
      </div>
    </ng-container>
  </div>
</app-modal-container>
